import React, { useMemo } from 'react';

import { parseNestedAdfDocument } from '@confluence/macro-utils/entry-points/nestedAdfRenderer.ts';

import { PageIncludeContextProvider } from '../contexts/PageIncludeContext.tsx';
import type { PageIncludeRendererWrapperProps, ResolvedTarget } from '../pageIncludeMacroTypes.ts';

export type PageIncludeContentProps = {
	resolvedTarget: ResolvedTarget;
	adfString: string;
	mediaToken?: string;
	macroId?: string;
	RendererWrapper: React.ComponentType<PageIncludeRendererWrapperProps>;
};

export const PageIncludeContent = ({
	resolvedTarget,
	adfString,
	mediaToken,
	macroId,
	RendererWrapper,
}: PageIncludeContentProps): React.JSX.Element => {
	const adfDocument = useMemo(() => parseNestedAdfDocument(adfString), [adfString]);
	const adfContent = adfDocument.content;

	return (
		<PageIncludeContextProvider contentId={resolvedTarget.contentId} title={resolvedTarget.title}>
			<RendererWrapper
				adf={adfContent}
				targetContentId={resolvedTarget.contentId}
				targetSpaceKey={resolvedTarget.spaceKey}
				targetSpaceId={resolvedTarget.spaceId}
				mediaToken={mediaToken}
				headingIdPrefix={macroId}
			/>
		</PageIncludeContextProvider>
	);
};
